import { ChangeDetectorRef, Component, inject, NgZone, OnInit, ViewChild } from '@angular/core';
import { NavigationStart, Router, RouterOutlet } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { NewVersionModalComponent } from '@cinetixx/cinetixx-ui';
import { interval } from 'rxjs';
import { filter } from 'rxjs/operators';
import { languagesSnippets$ } from './language/core/guards';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet, NewVersionModalComponent]
})
export class AppComponent implements OnInit {

  @ViewChild('newVersionModalComponent') newVersionModalComponent: NewVersionModalComponent;

  public isLoaderVisible = true;
  public isNewVersionModalVisible = false;

  private readonly _router = inject(Router);
  private readonly _swUpdate = inject(SwUpdate);
  private readonly _cdr = inject(ChangeDetectorRef);
  private readonly _ngZone = inject(NgZone);


  public ngOnInit(): void {
    const reloadPageTimeout = setTimeout(() => {
      if (document.readyState !== 'complete') {
        window.location.reload();
      }
    }, 20000);

    this._router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        clearTimeout(reloadPageTimeout);
      }
    });

    languagesSnippets$.subscribe(() => {
      this.isNewVersionModalVisible = true;
      this._cdr.detectChanges();
    });

    if (this._swUpdate.isEnabled) {
      this._ngZone.runOutsideAngular(() => {
        const interval$ = interval(1000 * 10).subscribe(() => {
          this._swUpdate.checkForUpdate().then(isNewVersion => {
            console.log('isNewVersion', isNewVersion);

            if (isNewVersion) {
              interval$.unsubscribe();
              this.newVersionModalComponent.open();
            }
          });
        })
      });

      this._swUpdate.versionUpdates.subscribe(x => console.log(x));
      this._swUpdate.versionUpdates.pipe(
        filter(event => event.type === 'VERSION_READY')
      ).subscribe(() => this.newVersionModalComponent.open());
    }
  }
}
